import { ReactElement, useContext } from 'react';
import { useTranslation } from 'next-i18next';
import { Link, Prices } from 'hah-fe-core/dist/components';
import { sitewideDiscount } from '~/constants/siteConfig';
import { getPrices } from 'hah-fe-core/dist/utils/price';
import { CoreContext } from 'hah-fe-core/dist/context';
import { useRouter } from 'next/router';
import { computedWithDiscount, computePrices } from 'hah-fe-core/dist/utils';
// static prices in EUR
const staticPrices = [
  // Novotel bed & bedding complete
  {
    maxRegular: 266,
    minRegular: 221,
    discount: sitewideDiscount,
    isPercentage: true,
  },
];

const LinenSection = (): ReactElement => {
  const { t: tHome } = useTranslation('', { keyPrefix: '$pages.$home.$linen' });
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });

  const {
    data: { currency, promotion },
  } = useContext(CoreContext);

  const prices = computedWithDiscount(staticPrices, promotion?.promo_is_active);
  const staticPrice = computePrices(prices);

  const currentCurrency = currency;
  const { locale } = useRouter();

  return (
    <section id="hp-linen" className="hp-linen hp-section">
      <div className="hp-content-wrapper">
        <Link
          href={tHome('link')}
          data-event-name="bloc_interact"
          data-bloc-name={tHome('heading')}
        >
          <div className="linen-left">
            <h2>{tHome('heading')}</h2>
            <Prices prices={getPrices(staticPrice[0][currentCurrency], locale)} show />
            <p>{tHome('description')}</p>
            <button className="btn-main" type="button">
              {tHome('cta')}
            </button>
          </div>
          <div className="linen-right">
            <div className="hover-btn-animation">
              <picture>
                <source srcSet="images/homePage/banners/hp-linen-set-novotel-desktop.webp" />
                <img
                  src="images/homePage/banners/hp-linen-set-novotel-desktop.jpg"
                  alt={tHome('cta')}
                  width={576}
                  height={385}
                  loading="lazy"
                />
              </picture>
              <div className="hover-content desktop-only">
                <span className="btn base-btn btn-main">
                  <span>{tButton('shopNow')}</span>
                </span>
              </div>
            </div>
          </div>
        </Link>
      </div>
    </section>
  );
};

export default LinenSection;
